
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Icons } from '@/components/icons';

const Features = () => {
  return (
    <div className="flex flex-col min-h-screen">


      {/* Hero Section */}
      <section className="py-16 md:py-24 bg-[#F8F9FF]">
        <div className="container mx-auto px-4 sm:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8">Discover Our Features</h1>
          <p className="text-xl text-gray-600 text-center max-w-3xl mx-auto mb-16">
            Explore all the powerful tools Discovery Hub offers to supercharge your lead generation and management.
          </p>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Location-Based Search</h3>
              <p className="text-gray-600">Find businesses based on geographic location with advanced search filters and radius targeting.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.3-4.3"></path>
                  <path d="M11 8v6"></path>
                  <path d="M8 11h6"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Custom Lead Scoring</h3>
              <p className="text-gray-600">Automatically score and prioritize leads based on fit, intent, and engagement signals.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <path d="M16 13H8"></path>
                  <path d="M16 17H8"></path>
                  <path d="M10 9H8"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Lead Management</h3>
              <p className="text-gray-600">Organize your leads with custom categories, status tracking, notes, and task management.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <path d="M17 18a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2"></path>
                  <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                  <circle cx="12" cy="10" r="3"></circle>
                  <path d="M6 20v1"></path>
                  <path d="M18 20v1"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Team Collaboration</h3>
              <p className="text-gray-600">Collaborate with your sales team with shared access, assignment features, and activity tracking.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <path d="M12 2v4"></path>
                  <path d="M12 18v4"></path>
                  <path d="M4.93 4.93l2.83 2.83"></path>
                  <path d="M16.24 16.24l2.83 2.83"></path>
                  <path d="M2 12h4"></path>
                  <path d="M18 12h4"></path>
                  <path d="M4.93 19.07l2.83-2.83"></path>
                  <path d="M16.24 7.76l2.83-2.83"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Automated Enrichment</h3>
              <p className="text-gray-600">Automatically gather business details, contact information, and social profiles for each lead.</p>
            </div>
            
            <div className="bg-white p-8 rounded-xl border border-gray-100 shadow-sm">
              <div className="inline-flex w-12 h-12 items-center justify-center bg-blue-100 rounded-lg text-primary mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
                  <path d="M3 3v18h18"></path>
                  <path d="m19 9-5 5-4-4-3 3"></path>
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-3">Analytics Dashboard</h3>
              <p className="text-gray-600">Track lead conversion metrics, team performance, and sales pipeline analytics.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-white">
        <div className="container mx-auto px-4 sm:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Ready to Transform Your Lead Generation?</h2>
          <p className="text-white/80 max-w-2xl mx-auto mb-8">Join our beta program today and be among the first to experience Discovery Hub's powerful features.</p>
          <Button size="lg" variant="outline" className="bg-white text-primary hover:bg-white/90" asChild>
            <Link to="/auth">Join Beta Now</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Features;
